<template>
  <div class="navbar-user-container">
    <div class="user-logo-container cursor-pointer">
      <v-avatar color="#313336">
        {{ getInitials() }}
      </v-avatar>
    </div>
    <NavBarUserMenu />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import NavBarUserMenu from './NavBarUserMenu.vue'
import { useAppStore } from '@/stores/appStore'

export default defineComponent({
  name: 'UserAvatar',
  setup () {
    const appStore = useAppStore()
    return {
      appStore
    }
  },
  components: {
    NavBarUserMenu
  },
  methods: {
    getInitials (): string {
      const fullName = (this.appStore.getAppState.userProfile?.firstName || '') + ' ' + (this.appStore.getAppState.userProfile?.lastName || '')
      const nameParts = fullName.trim().split(' ')
      const initials = nameParts.map((part: string) => part.charAt(0).toUpperCase())
      return initials.join('')
    }
  }
})
</script>

<style lang="scss">
.navbar-user-container {

  * {
    // All child elements
    padding: 0.3em 0.8em;
  }

  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;

  // background-color: $blue-tertiary;

  .user-logo-container {
    grid-column: 1 / 2;
  }

}
</style>
